import QuestionView from "./QuestionView";

export default class QuestionViewVerbalStatic extends QuestionView{
    constructor(question) {
        super(question);
        this._confirmButton.x = this._footer.x + 400;

        this._inputField.position.set(0, 0);
        this._footer.addChild(this._inputField);
    }

    getHeaderText() {
        return this.question.data.question_copy;
    }
}